import { render, staticRenderFns } from "./FeeHistories.vue?vue&type=template&id=f7535be2&scoped=true&"
import script from "./FeeHistories.vue?vue&type=script&lang=js&"
export * from "./FeeHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7535be2",
  null
  
)

export default component.exports